import { Component, OnInit, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../../services/auth.service';
import { ButtonComponent } from '../button/button.component';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'app-user-dropdown',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule, ButtonComponent, UserAvatarComponent],
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss'],
})
export class UserDropdownComponent implements OnInit {
  @Input() userName: string = '';
  @Input() userEmail: string = '';
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  @Input() photo: SafeUrl | string | null = null;
  @Input() profileLink: string | any[] | null = null;
  @Input() myJobsLink: string | any[] | null = null;
  @Input() settingsLink: string | any[] | null = null;
  /**
   * Render mode: when `true` the trigger button is hidden, the menu is
   * rendered inline (always visible, static positioning, no card chrome,
   * no internal dividers, no profile link). Used by the mobile drawer in
   * the header so it doesn't have to ::ng-deep + !important its way over
   * a desktop-styled dropdown.
   */
  @Input() inline = false;
  isOpen = false;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {}

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  closeDropdown(): void {
    this.isOpen = false;
  }

  logout(): void {
    this.authService.logout();
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.user-dropdown')) {
      this.isOpen = false;
    }
  }
}
